import { render, staticRenderFns } from "./rectangle-nft.vue?vue&type=template&id=0f54bce9"
import script from "./rectangle-nft.vue?vue&type=script&lang=js"
export * from "./rectangle-nft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports